export default {
  jsonBaseUrl: "../json/",
  imgBaseUrl: "../imgs/",
  id:0,//干货详情id
  title:"",
  Authorization:"",//token
  headimgurl:"",//wx头像
  nickname:'',//wxname
  status:'',//是否为新用户
  isactive:'0',//是否从项目进活动页
  x:0,//标签index
  school_name:'',//学校名称
  news:{},//标签信息
  schoolFlag:0,
}



// WEBPACK FOOTER //
// ./src/store/state.js